/**
 * The backend's refusal of a self-service admission — starting a subscription
 * or redeeming a code — by someone whose email address is not verified
 * (#2037). It answers `403` with the body's `error` set to
 * `EMAIL_NOT_VERIFIED`, read from a fresh Auth record, so it can arrive even
 * when this app's own checks passed on a token that predates an un-verify.
 *
 * Matched on the code, never on the status alone (other 403s exist) and never
 * on the message (prose is not a contract). Duck-typed rather than
 * `instanceof ApiHttpError`, so it holds wherever the error was constructed.
 */

export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';

export const EMAIL_NOT_VERIFIED_MESSAGES = {
  purchase:
    'Please verify your email address before subscribing. Open the verification link we emailed you, and if the page it opens asks you to confirm, press its confirmation button.',
  redeem:
    'Please verify your email address before redeeming a code. Open the verification link we emailed you, and if the page it opens asks you to confirm, press its confirmation button.',
} as const;

export function isEmailNotVerifiedError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { code?: unknown }).code === EMAIL_NOT_VERIFIED
  );
}
